import { ReactElement } from 'react';
import { useContentHeight } from 'hooks/useContentHeight';

export const FallbackContainer = (): ReactElement => {
  const contentHeight = useContentHeight();

  return <div style={{ height: contentHeight }} />;
};
